import React from 'react';
import { Pill } from './Pill';
export const PillsBar = ({ users, onRemove, sortByTime, onToggleSort }) => {
  return (
    <div className="absolute top-16 left-4 z-40 flex flex-wrap gap-2">
      {users.map((u) => (
        <Pill
          key={u.id}
          label={u.id.toString()}
          onClose={() => onRemove(u.id)}
        />
      ))}
      <Pill
        label={`Sort by Time${sortByTime ? ' ✔' : ''}`}
        onClose={onToggleSort}
      />
    </div>
  );
};
